export default __webpack_public_path__ + "static/media/land-poster.3ac6834c.png";